// Prod: API Gateway. Локал турших: localhost / LAN IP-г идэвхжүүлж, prod-ийг комментлоорой.
const BASE_SERVER_PATH = 'https://p5afw4zfc3.execute-api.ap-southeast-1.amazonaws.com/prod/api'
// const BASE_SERVER_PATH = 'http://localhost:3000/api'
// const BASE_SERVER_PATH = 'http://192.168.1.28:3000/api'

export default {
  BASE_SERVER_PATH: BASE_SERVER_PATH
}
